import _regeneratorRuntime from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { IK } from "./handshakes/ik";
import { Buffer } from "buffer";
import { decode0, decode1, encode0, encode1 } from "./encoder";
import { decodePayload, getPeerIdFromPayload, verifySignedPayload } from "./utils";
import { FailedIKError } from "./errors";
import { logger, logLocalStaticKeys, logRemoteStaticKey, logLocalEphemeralKeys, logRemoteEphemeralKey, logCipherState } from "./logger";
export var IKHandshake = /*#__PURE__*/function () {
  function IKHandshake(isInitiator, payload, prologue, staticKeypair, connection, remoteStaticKey, remotePeer, handshake) {
    _classCallCheck(this, IKHandshake);

    _defineProperty(this, "isInitiator", void 0);

    _defineProperty(this, "session", void 0);

    _defineProperty(this, "remotePeer", void 0);

    _defineProperty(this, "remoteEarlyData", void 0);

    _defineProperty(this, "payload", void 0);

    _defineProperty(this, "prologue", void 0);

    _defineProperty(this, "staticKeypair", void 0);

    _defineProperty(this, "connection", void 0);

    _defineProperty(this, "ik", void 0);

    this.isInitiator = isInitiator;
    this.payload = Buffer.from(payload);
    this.prologue = prologue;
    this.staticKeypair = staticKeypair;
    this.connection = connection;

    if (remotePeer) {
      this.remotePeer = remotePeer;
    }

    this.ik = handshake || new IK();
    this.session = this.ik.initSession(this.isInitiator, this.prologue, this.staticKeypair, remoteStaticKey);
    this.remoteEarlyData = Buffer.alloc(0);
  }

  _createClass(IKHandshake, [{
    key: "stage0",
    value: function () {
      var _stage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var messageBuffer, receivedMsg, receivedMessageBuffer, _this$ik$recvMessage, plaintext, valid, decodedPayload;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                logLocalStaticKeys(this.session.hs.s);
                logRemoteStaticKey(this.session.hs.rs);

                if (!this.isInitiator) {
                  _context.next = 10;
                  break;
                }

                logger("IK Stage 0 - Initiator sending message...");
                messageBuffer = this.ik.sendMessage(this.session, this.payload);
                this.connection.writeLP(encode1(messageBuffer));
                logger("IK Stage 0 - Initiator sent message.");
                logLocalEphemeralKeys(this.session.hs.e);
                _context.next = 40;
                break;

              case 10:
                logger("IK Stage 0 - Responder receiving message...");
                _context.next = 13;
                return this.connection.readLP();

              case 13:
                receivedMsg = _context.sent;
                _context.prev = 14;
                receivedMessageBuffer = decode1(receivedMsg.slice());
                _this$ik$recvMessage = this.ik.recvMessage(this.session, receivedMessageBuffer), plaintext = _this$ik$recvMessage.plaintext, valid = _this$ik$recvMessage.valid;

                if (valid) {
                  _context.next = 19;
                  break;
                }

                throw new Error("ik handshake stage 0 decryption validation fail");

              case 19:
                logger("IK Stage 0 - Responder got message, going to verify payload.");
                _context.next = 22;
                return decodePayload(plaintext);

              case 22:
                decodedPayload = _context.sent;
                _context.t0 = this.remotePeer;

                if (_context.t0) {
                  _context.next = 28;
                  break;
                }

                _context.next = 27;
                return getPeerIdFromPayload(decodedPayload);

              case 27:
                _context.t0 = _context.sent;

              case 28:
                this.remotePeer = _context.t0;
                _context.next = 31;
                return verifySignedPayload(this.session.hs.rs, decodedPayload, this.remotePeer);

              case 31:
                this.setRemoteEarlyData(decodedPayload.data);
                logger("IK Stage 0 - Responder successfully verified payload!");
                logRemoteEphemeralKey(this.session.hs.re);
                _context.next = 40;
                break;

              case 36:
                _context.prev = 36;
                _context.t1 = _context["catch"](14);
                logger("Responder breaking up with IK handshake in stage 0.");
                throw new FailedIKError(receivedMsg, "Error occurred while verifying initiator's signed payload: ".concat(_context.t1.message));

              case 40:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[14, 36]]);
      }));

      function stage0() {
        return _stage.apply(this, arguments);
      }

      return stage0;
    }()
  }, {
    key: "stage1",
    value: function () {
      var _stage2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var receivedMsg, receivedMessageBuffer, _this$ik$recvMessage2, plaintext, valid, decodedPayload, messageBuffer;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.isInitiator) {
                  _context2.next = 33;
                  break;
                }

                logger("IK Stage 1 - Initiator receiving message...");
                _context2.next = 4;
                return this.connection.readLP();

              case 4:
                receivedMsg = _context2.sent.slice();
                receivedMessageBuffer = decode0(Buffer.from(receivedMsg));
                _this$ik$recvMessage2 = this.ik.recvMessage(this.session, receivedMessageBuffer), plaintext = _this$ik$recvMessage2.plaintext, valid = _this$ik$recvMessage2.valid;
                logger("IK Stage 1 - Initiator got message, going to verify payload.");
                _context2.prev = 8;

                if (valid) {
                  _context2.next = 11;
                  break;
                }

                throw new Error("ik stage 1 decryption validation fail");

              case 11:
                _context2.next = 13;
                return decodePayload(plaintext);

              case 13:
                decodedPayload = _context2.sent;
                _context2.t0 = this.remotePeer;

                if (_context2.t0) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 18;
                return getPeerIdFromPayload(decodedPayload);

              case 18:
                _context2.t0 = _context2.sent;

              case 19:
                this.remotePeer = _context2.t0;
                _context2.next = 22;
                return verifySignedPayload(receivedMessageBuffer.ns.slice(0, 32), decodedPayload, this.remotePeer);

              case 22:
                this.setRemoteEarlyData(decodedPayload.data);
                logger("IK Stage 1 - Initiator successfully verified payload!");
                logRemoteEphemeralKey(this.session.hs.re);
                _context2.next = 31;
                break;

              case 27:
                _context2.prev = 27;
                _context2.t1 = _context2["catch"](8);
                logger("Initiator breaking up with IK handshake in stage 1.");
                throw new FailedIKError(receivedMsg, "Error occurred while verifying responder's signed payload: ".concat(_context2.t1.message));

              case 31:
                _context2.next = 38;
                break;

              case 33:
                logger("IK Stage 1 - Responder sending message...");
                messageBuffer = this.ik.sendMessage(this.session, this.payload);
                this.connection.writeLP(encode0(messageBuffer));
                logger("IK Stage 1 - Responder sent message...");
                logLocalEphemeralKeys(this.session.hs.e);

              case 38:
                logCipherState(this.session);

              case 39:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 27]]);
      }));

      function stage1() {
        return _stage2.apply(this, arguments);
      }

      return stage1;
    }()
  }, {
    key: "decrypt",
    value: function decrypt(ciphertext, session) {
      var cs = this.getCS(session, false);
      return this.ik.decryptWithAd(cs, Buffer.alloc(0), ciphertext);
    }
  }, {
    key: "encrypt",
    value: function encrypt(plaintext, session) {
      var cs = this.getCS(session);
      return this.ik.encryptWithAd(cs, Buffer.alloc(0), plaintext);
    }
  }, {
    key: "getLocalEphemeralKeys",
    value: function getLocalEphemeralKeys() {
      if (!this.session.hs.e) {
        throw new Error("Ephemeral keys do not exist.");
      }

      return this.session.hs.e;
    }
  }, {
    key: "getCS",
    value: function getCS(session) {
      var encryption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (!session.cs1 || !session.cs2) {
        throw new Error("Handshake not completed properly, cipher state does not exist.");
      }

      if (this.isInitiator) {
        return encryption ? session.cs1 : session.cs2;
      } else {
        return encryption ? session.cs2 : session.cs1;
      }
    }
  }, {
    key: "setRemoteEarlyData",
    value: function setRemoteEarlyData(data) {
      if (data) {
        this.remoteEarlyData = Buffer.from(data.buffer, data.byteOffset, data.length);
      }
    }
  }]);

  return IKHandshake;
}();